module.exports = __webpack_public_path__ + "img/cd.b070cb89.svg";